<template>
  <v-row no-gutters justify="center" align="start" class="auth-layout fill-height pt-10">
    <div class="bg-overlay">&nbsp;</div>
    <template v-if="isGlobalApp">
      <div class="auth-container">
        <div class="auth-content-wrapper mt-4 pt-8 pa-4 pb-8">
          <v-row no-gutters justify="center" align="center">
            <img src="@/assets/logo_white_no_bg.png" class="banner-logo" />
          </v-row>
          <div class="auth-content pb-2 px-4" v-if="areInitialDatasFetched && !isLoading && !spaces.length">
            <div class="pt-6">
              <router-view></router-view>
            </div>
          </div>
        </div>
        <v-row no-gutters justify="center" align="center" class="my-6" v-if="isLoading || !areInitialDatasFetched">
          <v-progress-circular indeterminate color="primary darken-1"></v-progress-circular>
        </v-row>
        <template v-else>
          <div class="auth-space-selector-wrapper" v-if="spaces.length && spaces.length > 1">
            <space-selector :spaces="spaces" can-logout />
          </div>
          <v-row no-gutters justify="center" align="center" class="my-6" v-else-if="spaces.length">
            <v-progress-circular indeterminate color="primary darken-1"></v-progress-circular>
          </v-row>
        </template>
      </div>
    </template>
    <div class="auth-container" v-else>
      <div class="auth-content-wrapper mt-4 pt-8 pa-4 pb-8">
        <v-row no-gutters justify="center" align="center">
          <img src="@/assets/logo_white_no_bg.png" class="banner-logo" />
        </v-row>
        <div class="auth-content pb-2 px-4">
          <template v-if="hasCompany">
            <div class="py-5 mb-2">
              <n-card class="pa-3" style="background-color: transparent !important; border-color: rgba(255,255,255, 0.3);">
                <v-row no-gutters justify="center" align="center" class="white--text font-weight-medium text-center">
                  {{ company.name }}
                </v-row>
              </n-card>
            </div>
            <router-view></router-view>
          </template>
          <n-card class="mt-10 pa-3" style="background-color: transparent !important; border-color: rgba(255,255,255, 0.3);" v-else>
            <v-row no-gutters justify="center" align="center" class="white--text font-weight-medium text-center">
              Impossible de trouver une application à cette adresse
            </v-row>
          </n-card>
        </div>
      </div>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import SpaceSelector from '@/components/Auth/SpaceSelector.vue';

export default {
  name: `LayoutAuth`,

  data: () => ({
    isLoading: false,
  }),

  computed: {
    ...mapState(`ui/mainLayout`, [
      `areInitialDatasFetched`,
    ]),
    ...mapGetters(`ui/mainLayout`, [
      `isGlobalApp`,
    ]),
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`model/auth`, [
      `spaces`,
    ]),
    hasCompany() {
      return Boolean(this.company && this.company.id);
    },
  },

  methods: {
    ...mapActions(`model/auth`, [
      `logout`,
    ]),
    ...mapActions(`model/user`, [
      `fetchMe`,
    ]),
  },

  async beforeMount() {
    if (this.$route.name === `logout`) {
      await this.logout();
      this.isLoading = true;
      try {
        this.$router.replace({ name: `login` });
      } catch(e) {} // eslint-disable-line
    }
  },

  watch: {
    $route() {
      this.isLoading = false;
    },
    spaces(spaces) {
      if (spaces.length && spaces.length === 1 && this.isGlobalApp) {
        const [space] = this.spaces;
        let ssoUrl = `${space.slugUrl}/sso?token=${space.ssoToken}&logout=0`;
        if (this.$route.query.redirect === `/data-exports`) ssoUrl += `&r=${encodeURIComponent(`/data-exports`)}`;

        if (ssoUrl.indexOf(`http:`) !== 0) {
          const protocol = window.location.protocol; // eslint-disable-line
          ssoUrl = `${protocol}//${ssoUrl}`;
        }

        window.location.href = ssoUrl;
      }
    },
  },

  components: {
    SpaceSelector,
  },
};
</script>

<style lang="scss">
.auth-layout {
  // background: rgb(28,13,140);
  // background: -moz-linear-gradient(45deg, rgba(28,13,140,1) 0%, rgba(92,51,226,1) 100%);
  // background: -webkit-linear-gradient(45deg, rgba(28,13,140,1) 0%, rgba(92,51,226,1) 100%);
  // background: linear-gradient(45deg, rgba(28,13,140,1) 0%, rgba(92,51,226,1) 100%);
  // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1c0d8c",endColorstr="#5c33e2",GradientType=1);

  .bg-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url("../assets/abstract-login-overlay.jpg");
    z-index: 1;
    background-size: cover;
    opacity: .3;
  }

  .auth-container {
    width: 420px;
    max-width: 90%;
  }
  // .auth-content-wrapper,
  // .auth-space-selector-wrapper {
  //   width: 420px;
  //   max-width: 90%;
  // }

  .auth-content-wrapper {
    z-index: 2;
    background: #13169a;
    -webkit-box-shadow: 0px 0px 25px 0px rgba(50, 50, 50, 1);
    -moz-box-shadow:    0px 0px 25px 0px rgba(50, 50, 50, 1);
    box-shadow:         0px 0px 25px 0px rgba(50, 50, 50, 1);
    border-radius: 10px;
  }
  .auth-content {
    color: #FFF;
  }
  .banner-logo {
    width: 80%;
    max-width: 250px;
  }

  // .company-name {
  //   color: #FFF;
  // }
}
</style>
